import { VkSuccessPage } from '@/app/pages/auth/vk/vk-success-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/auth/vk-success')({
  component: VkSuccessPage,
});
